/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/scripts/helpers/utils.js
/**
 * Helper: Utils
 * ------------------------------------------------------------------------------
 * Frame utility functions.
 *
 * @namespace utils
 */

/**
 * Get unique objects from object literal.
 * @param {Object} object - Array/Object to remove duplicates from.
 */
function unique(object) {
  return object.filter((value, index, self) => self.indexOf(value) === index);
}

/**
 * Get the difference of two arrays.
 * @param {Array} array - An array containing two arrays to diff.
 */
function difference(array1, array2) {
  return array1.concat(array2).filter((value, index, self) => {
    return self.indexOf(value) === self.lastIndexOf(value);
  });
}

/**
 * Combine two objects using properties as the override.
 * @param {object} defaults - Defaults options defined in script.
 * @param {object} properties - Options defined by user.
 * @return {object} - Defaults modified options.
 */
function extendDefaults(defaults, properties) {
  for (const property in properties) {
    if (properties != null && typeof properties !== 'undefined') {
      defaults[property] = properties[property];
    }
  }
  return defaults;
}

/**
  * Retrieves input data from a form.
  * @param {HTMLForm} form - HTML form elements.
  * @returns {Object} - Form data as an object literal.
  */
function formToJSON(elements) {
  return [].reduce.call(elements, (data, element) => {
    if (element.name && element.value) {
      data[element.name] = element.value;
    }
    return data;
  }, {});
}

/**
 * Serialize all form data into a query string.
 * @param {Node} form - The form to serialize.
 * @return {String} - The serialized form data.
 */
function serialize(form) {
  const serialized = [];

  /**
   * Loop through each field in the form.
   */
  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
      continue;
    }

    /**
     * If a multi-select, get all selections.
     */
    if (field.type === 'select-multiple') {
      for (let counter = 0; counter < field.options.length; counter++) {
        if (!field.options[counter].selected) {
          continue;
        }
        serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.options[counter].value)}`);
      }
    } else if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
      serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
    }
  }
  return serialized.join('&');
}

/**
 * Shortcut function to add an event listener.
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {String} event -The event type.
 * @param {Node} elem - The element to attach the event to (optional, defaults to window).
 * @param {Function} callback - The callback to run on the event.
 * @param {Boolean} capture - If true, forces bubbling on non-bubbling events.
 */
function on(event, elem = window, callback, capture = false) {
  /**
   * If only a string is passed into the element parameter.
   */
  if (typeof elem === 'string') {
    document.querySelector(elem).addEventListener(event, callback, capture);
    return;
  }

  /**
   * If an element is not defined in parameters, then shift callback across.
   */
  if (typeof elem === 'function') {
    window.addEventListener(event, elem);
    return;
  }

  /**
   * Default listener.
   */
  if (elem) {
    elem.addEventListener(event, callback, capture);
  }
}

/**
 * Get all siblings of an element.
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {Node} elem - The element you want get the siblings of.
 * @return {Array} - The siblings.
 */
function getSiblings(elem) {
  return Array.prototype.filter.call(elem.parentNode.children, sibling => {
    return sibling !== elem;
  });
}

/**
 * Render function.
 * @param {String} template - The template string to render.
 * @param {Node} node - The node to render into.
 */
function render(template, node) {
  if (!node) {
    return;
  }
  node.innerHTML = template;
}

/**
 * Browser detect and return a string
 * - https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
 * @returns {String} browser string.
 */
function getBrowser() {
  const userAgent = window.navigator.userAgent;

  // The order matters here, and this may report false positives for unlisted browsers.
  if (userAgent.indexOf('Firefox') > -1) {
    // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
    return 'Firefox';
  } else if (userAgent.indexOf('Opera') > -1) {
    return 'Opera';
  } else if (userAgent.indexOf('Trident') > -1) {
    // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
    return 'Internet Explorer';
  } else if (userAgent.indexOf('Edge') > -1) {
    // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
    return 'Edge';
  } else if (userAgent.indexOf('Chrome') > -1) {
    // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
    return 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
    return 'Safari';
  }
  return 'unknown';
}

/* Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 *
 * @param {Element} el
 * @return {String}
 */
function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    const container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

/**
 * Check if object is a HTMLElement.
 * @param {object} element - HTML element to check.
 */
function isElement(element) {
  return element instanceof window.Element || element instanceof window.HTMLDocument;
}

/**
 * Get query parameters as an object.
 * @return {Object} - Query object.
 */
function getQueryParamsObject() {
  const result = {};
  const parser = document.createElement('a');
  parser.href = window.location.href;
  const query = parser.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    result[pair[0]] = decodeURIComponent(pair[1]);
  }
  return result;
}
;// CONCATENATED MODULE: ./src/scripts/components/newsletter-preferences.js
/**
 * Component: Newsletter preferences script
 * ------------------------------------------------------------------------------
 * Script that handles user's newsletter preferences checkbox interactions.
 *
 * @namespace newsletterPreferences
 */



/**
 * DOM selectors.
 */
const selectors = {
  checkboxContainer: '[js-register="checkboxContainer"]',
  checkbox: '[js-register="checkbox"]',
  checkboxAll: '[js-register="checkboxAll"]',
  tags: '[js-register="tags"]',
  jsRegister: 'js-register',
  form: '[js-register="form"]'
};

/**
 * Create a new notification object.
 */
/* harmony default export */ const newsletter_preferences = (() => {
  /**
   * DOM node selectors.
   * Using getters to keep selectors within form.
   */
  const nodeSelectors = {
    checkboxContainer: document.querySelector(selectors.checkboxContainer),
    get form() {
      return this.checkboxContainer.closest(selectors.form);
    },
    get tags() {
      return this.form.querySelector(selectors.tags);
    },
    get checkboxAll() {
      return this.form.querySelector(selectors.checkboxAll);
    },
    get checkbox() {
      return this.form.querySelectorAll(selectors.checkbox);
    }
  };

  /**
   * Ticks the 'All' checkbox if all subcategory checkboxes are checked.
   */
  function isAllChecked() {
    const checkboxCount = nodeSelectors.checkbox.length;
    let checkedCount = 0;
    for (const checkbox of nodeSelectors.checkbox) {
      if (checkbox.checked) {
        checkedCount += 1;
      }
    }
    if (checkboxCount === checkedCount) {
      nodeSelectors.checkboxAll.checked = true;
    } else {
      nodeSelectors.checkboxAll.checked = false;
    }
  }

  /**
   *
   * @param {Object} event - Click event object.
   */
  function handleCheckboxes(event) {
    const target = event.target;
    const hasAttribute = target.hasAttribute(selectors.jsRegister);
    if (hasAttribute) {
      const targetAttribute = target.getAttribute(selectors.jsRegister);
      if (targetAttribute === 'checkbox') {
        isAllChecked();
        setCustomerTags();
        return event;
      }
      if (targetAttribute === 'checkboxAll') {
        const isChecked = target.checked;
        nodeSelectors.checkbox.forEach(item => {
          item.checked = isChecked;
        });
        setCustomerTags();
        return event;
      }
    }
    return event;
  }

  /**
   * Sets the selected customer tag checkboxes.
   */
  function setCustomerTags() {
    const customerTags = [];
    [...nodeSelectors.checkbox].forEach(item => {
      if (item.checked) {
        customerTags.push(item.value);
      }
    });

    // Additional 'newsletter_accepted_on_registration' added to differentiate between here
    // and checkout, as Shopify Flow will need to listen for this flag to know
    // if to assign customer tags if the user ticks "newsletter" on checkout.
    if (customerTags && customerTags.length) {
      customerTags.push('newsletter_accepted_on_registration');
    }
    nodeSelectors.tags.value = customerTags.join(',');
  }

  /**
   * Register page event listeners.
   */
  function setEventListeners() {
    if (!nodeSelectors.checkboxContainer) {
      return;
    }
    on('click', nodeSelectors.checkboxContainer, event => handleCheckboxes(event));
  }

  /**
   * Initialize address form events.
   */
  function init() {
    setEventListeners();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init
  });
});
;// CONCATENATED MODULE: ./src/scripts/components/validate-register-input.js
/**
 * Component: Checks the name inputs on registration page and
 * denies submission if they contain a numerical input.
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function.
 *
 * @namespace ValidateRegisterInputs
 */



/**
 * DOM selectors.
 */
const validate_register_input_selectors = {
  registerForm: '[js-validate-register="registerForm"]',
  nameInput: '[js-validate-register="nameInput"]',
  formErrors: '.errors'
};

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */
/* harmony default export */ const validate_register_input = (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    registerForm: document.querySelector(validate_register_input_selectors.registerForm),
    nameInput: [...document.querySelectorAll(validate_register_input_selectors.nameInput)],
    formErrors: document.querySelector(validate_register_input_selectors.formErrors)
  };
  function checkNameInputValid() {
    let containsNumbers = true;
    for (const input of nodeSelectors.nameInput) {
      const matches = input.value.match(/\d+/g);
      if (matches != null) {
        containsNumbers = false;
      }
    }
    return containsNumbers;
  }

  /**
   * Creates the structure for the inline error element and inserts it.
   */
  function renderNameErrors() {
    const errorList = nodeSelectors.registerForm.querySelector('.errors ul');
    const errorMessage = 'Names cannot include numerical characters';
    let errorElement = `<div class="errors">
        <ul>
          <li>${errorMessage}</li>
        </ul>
      </div>`;
    let targetElem = nodeSelectors.registerForm;
    if (errorList) {
      targetElem = errorList;
      errorElement = `<li>${errorMessage}</li>`;
    }
    targetElem.insertAdjacentHTML('afterbegin', errorElement);
  }

  /**
   * Initialise component.
   */
  function init() {
    renderExistingValues();
    setEventListeners();
  }

  /**
   * On load, check if the form has been submitted with errors, and also
   * that the session storage exists. If both do, then populate the
   * relevant fields with the users information.
   */
  function renderExistingValues() {
    if (!nodeSelectors.formErrors) {
      return false;
    }
    if (sessionStorage.getItem('smg_registration_data') === null) {
      return false;
    }
    const formObject = JSON.parse(sessionStorage.getItem('smg_registration_data'));
    for (const formItem of formObject) {
      nodeSelectors.registerForm.querySelector(`[name="${formItem.name}"]`).value = formItem.value;
    }
  }

  /**
   * Set trigger listeners.
   */
  function setEventListeners() {
    on('submit', nodeSelectors.registerForm, event => {
      event.preventDefault();
      const canSubmit = checkNameInputValid();
      if (canSubmit === true) {
        preserveUserInformation(event);
        nodeSelectors.registerForm.submit();
      } else {
        renderNameErrors();
      }
    });
  }

  /**
   *
   * @param {Object} event - The captured event that is retreived from the
   * registration submission event.
   */
  function preserveUserInformation(event) {
    const formData = [];
    for (const field of event.srcElement.elements) {
      if (field.name === '' || field.name === 'customer[password]') {
        continue;
      }
      formData.push({
        name: field.name,
        value: field.value
      });
    }
    sessionStorage.setItem('smg_registration_data', JSON.stringify(formData));
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init
  });
});
;// CONCATENATED MODULE: ./src/scripts/templates/customers/register.js
/**
 * Template: Register
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Register template.
 *
 * @namespace register
 */



document.addEventListener('DOMContentLoaded', () => {
  newsletter_preferences().init();
  validate_register_input().init();
});
/******/ })()
;